import { axiosInstance } from "../../../api/axiosInstance";
import { appCache } from "../../../cache/appCache";
import { AcademicYear, AcademicYearInitializationResult, AcademicYearSyncResult } from "../types";

// Any call that changes a year drops the cached list (appCache bucket "academicYears")
const refreshCachedYears = () => appCache.invalidate("academicYears");

// Public (pre-login) list - not cached
export const fetchPublicAcademicYears = async (): Promise<AcademicYear[]> => {
  const response = await axiosInstance.get<AcademicYear[]>("/public/academic-years");
  return response.data;
};

export const fetchAcademicYears = (): Promise<AcademicYear[]> =>
  appCache.getOrFetch("academicYears", () =>
    axiosInstance.get<AcademicYear[]>("/academic-years").then((response) => response.data)
  );

export const getAcademicYear = async (name: string): Promise<AcademicYear> => {
  const response = await axiosInstance.get<AcademicYear>(`/academic-years/${name}`);
  return response.data;
};

export const createAcademicYear = async (): Promise<AcademicYear> => {
  const response = await axiosInstance.post<AcademicYear>("/academic-years");
  refreshCachedYears();
  return response.data;
};

// Creates a CLOSED academic year just before the oldest one
export const createPreviousAcademicYear = async (): Promise<AcademicYear> => {
  const response = await axiosInstance.post<AcademicYear>("/academic-years/previous");
  refreshCachedYears();
  return response.data;
};

export const initializeAcademicYear =async (name: string): Promise<AcademicYearInitializationResult> => {
  const response = await axiosInstance.patch<AcademicYearInitializationResult>(`/academic-years/${name}/initialize`);
  refreshCachedYears();
  return response.data;
};

export const activateAcademicYear = async (name: string): Promise<AcademicYear> => {
  const response = await axiosInstance.post<AcademicYear>("/academic-years/" + name + "/activate");
  refreshCachedYears();
  return response.data;
};

export const syncActiveAcademicYear = async (): Promise<AcademicYearSyncResult> => {
  const response = await axiosInstance.post<AcademicYearSyncResult>("/academic-years/sync-active-academic-year");
  refreshCachedYears();
  return response.data;
};

export const closeAcademicYear = async (id: string): Promise<AcademicYear> => {
  const response = await axiosInstance.patch<AcademicYear>(`/academic-years/${id}/initialize`);
  refreshCachedYears();
  return response.data;
};
export const deleteAcademicYear = async (id: string): Promise<AcademicYear> => {
  const response = await axiosInstance.patch<AcademicYear>(`/academic-years/${id}/initialize`);
  refreshCachedYears();
  return response.data;
};
